import { useMutation } from '@tanstack/react-query';
import { bankApplicationsApi } from '@modules/opportunities/entities/bankApplication/api';
import { trackAmplitudeEvent } from '@shared/analytics/amplitude';
import { USER_EVENTS } from '@shared/analytics/events';
import useFeatureFlags from '@modules/core/hooks/useFeatureFlags';
import queryClient from '@app/queryClient';

const useSendDigitalDocument = (opportunityExternalId: string) => {
  const { isFeatureActive } = useFeatureFlags();
  const isFeatureFlagOn = isFeatureActive('opportunities.esignature');
  const {
    mutateAsync,
    isPending,
  } = useMutation({
    mutationKey: ['useSendDigitalDocument'],
    mutationFn: async ({ bankApplicationExternalId, digitalDocumentId }:
    { bankApplicationExternalId: string, digitalDocumentId: string }) => {
      // Track attempt
      trackAmplitudeEvent(USER_EVENTS.CASE.CASE_DIGITAL_BANK_FORM_VIEW_ATTEMPTED, { useContext: true });

      return bankApplicationsApi.sendDigitalBankApplication(
        {
          opportunityExternalId,
          bankApplicationExternalId,
          digitalDocumentId,
        },
        isFeatureFlagOn ? 'send-document' : 'send'
      );
    },
    onSuccess: async () => {
      await queryClient.refetchQueries({ queryKey: ['bankDigitalDocs', opportunityExternalId] });
      // Track success
      trackAmplitudeEvent(USER_EVENTS.CASE.CASE_DIGITAL_BANK_FORM_VIEW_COMPLETED, { useContext: true });
    },
    onError: (error) => {
      // Track fail
      trackAmplitudeEvent(USER_EVENTS.CASE.CASE_DIGITAL_BANK_FORM_VIEW_FAILED, {
        useContext: true,
        error_message: error.message ?? error,
      });
    },
    retry: 3,
    retryDelay: 3000,
  });

  return { mutateAsync, isPending };
};

export default useSendDigitalDocument;
